import { UIComponentState, UIComponentImpl, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { ForgotPasswordOTPViewImpl } from './forgotpasswordotpview';
import { ForgotPasswordOTPCSSStyleImpl } from './forgotpasswordotpcss';
import { ChildComponentProps } from '../../mainwrappercomponent';
import { ForgotPasswordOTPAPIModel, ForgotPasswordOTPAPIModelImpl } from './forgotpasswordotpapimodel';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
// import { CreateAccountOTPViewImpl } from '../createaccountotp/createaccountotpview';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { RoutingFeatures } from '../../navigation/routingfeature';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { SendOTPDto } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';
import { CreateAccountOTPViewImpl } from '../createaccountotp/createaccountotpview';

export interface ForgotPasswordOTPComponentProps extends ChildComponentProps
{

}
export interface ForgotPasswordOTPComponentState extends UIComponentState
{
   isOtpSuccess: boolean;
   sectoken: string;
   msisdn: string;
}
export interface ForgotPasswordOTPComponentHandler extends UIComponentHandler
{
    onRequestOtpClick():void;
    onLogoClicked(): void;
}
export class ForgotPasswordOTPComponent extends UIComponentImpl<ForgotPasswordOTPComponentProps, ForgotPasswordOTPComponentState, UIDataModel> implements ForgotPasswordOTPComponentHandler
{
    constructor(props: ForgotPasswordOTPComponentProps)
    {
        super(props);

        this.state = {isOtpSuccess: false, sectoken: "", msisdn: ""};
    }

    componentDidMount()
    {
        if(this.props.context.getUserContext().getIsLoggedIn())
       {
           this.props.context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, true);
       }
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ForgotPasswordOTPViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ForgotPasswordOTPCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ForgotPasswordOTPAPIModelImpl(applicationContext, apiModelHandler);
    }

    componentWillReceiveProps()
    {
        this.state = {isOtpSuccess: false, sectoken: "", msisdn: ""};
    }

    onLogoClicked(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.HOME, false);
    }
    onRequestOtpClick():void
    {
        if(this.getView().validate())
        {
            (this.getView() as ForgotPasswordOTPViewImpl).showLoader();
            this.getAPIModel().validateNumber((this.getView() as CreateAccountOTPViewImpl).getData());
        }
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as ForgotPasswordOTPViewImpl).dismissLoader();
        if(feature === APIFeatures.SEND_OTP)
        {
            this.setState({isOtpSuccess: true, 
                msisdn: (this.getView() as CreateAccountOTPViewImpl).getData().getMsisdn(), 
                sectoken :  (data as SendOTPDto).getSecToc()});
            // this.props.context.getUserContext().setMsisdnB(data);
              
            // this.props.context.setUserContext(this.props.context.getUserContext());
            // this.props.routeNextFeature(RoutingFeatures.FORGOT_PASSWORD_OTP, false);
        }
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as ForgotPasswordOTPViewImpl).dismissLoader();
        (this.getView() as ForgotPasswordOTPViewImpl).showPopup("",description,AlertType.ERROR);

    }

    getAPIModel(): ForgotPasswordOTPAPIModel 
    {
        return super.getAPIModel() as ForgotPasswordOTPAPIModel;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/forgotpasswordotp/forgotpasswordotpcomponent.tsx